'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './property-edit.routes';

export class PropertyEditComponent {
  constructor(Auth, $state, $stateParams, dialogs, CommunityService, PropertyService, $uibModal, SettingsService) {
    'ngInject';

    this.propertyId = $stateParams.id;
    this.states = [ "AL", "AK", "AS", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FM", "FL", "GA", "GU", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MH", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "MP", "OH", "OK", "OR", "PW", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VI", "VA", "WA", "WV", "WI", "WY" ];

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.PropertyService = PropertyService;
    this.CommunityService = CommunityService;
    this.SettingsService = SettingsService;
    this.Auth = Auth;

    this.SettingsService.getByName({name: 'custom-fields'}, customFieldSettings => {
      if (customFieldSettings.data.hasOwnProperty("property")) {
        this.customSchema = customFieldSettings.data.property;
        this.customForm = ["*"];
      }
    });

    this.schema = {};
    this.owners = [];

    this.CommunityService.query(data => {
      this.communities = data.map(cmty => {
        return {
          value: cmty._id,
          name: cmty.code + ": " + cmty.name
        };
      });
    });

    this.jsonValue = "";
    this.$state = $state;

    this.model = {
      address: {},
      customFields: {}
    };

    this.customFields = {};

    if (this.propertyId) {
      this.PropertyService.get({id: this.propertyId}, data => {
        this.model = data;

        if (this.model.community)
          this.model.community = this.model.community._id;

        this.customFields = this.model.customFields || {};
      }, err => {
        console.log('Could not load property from server');
      })
    }

  }

  communityLookup() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'communityLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (community) {
        that.model.community = community._id;
      },
      function () { /* cancel */ }
    );

  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        var actionString = (this.propertyId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "The property has been "+actionString+" successfully");
        dlg.result.then(() => {
          that.$state.go("property-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.model.customFields = this.customFields || {};

      if (this.propertyId) {  // Save changes on the current settings
        this.PropertyService.update({id: this.propertyId}, this.model, onSuccess, onError);
      } else { // Create new settings
        this.model.meta = {creationUser: this.Auth.getCurrentUserSync()._id};
        this.PropertyService.save(this.model, onSuccess, onError);
      }
    }
  }
}

export default angular.module('conduu.propertyEdit', [uiRouter])
  .config(routes)
  .component('propertyEdit', {
    template: require('./property-edit.html'),
    controller: PropertyEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/portfolio/property-edit/property-edit.component.js